import { SCREEN_SIZE } from '../../theme';

export const SCREEN_SIZE_FOR_TWO_OUTCOMES = SCREEN_SIZE.XXL;
export const SCREEN_SIZE_FOR_THREE_OUTCOMES = SCREEN_SIZE.XXXL;
export const SHOW_CASINO_GAMES_AFTER_INDEX = 2;
